import { Box } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout } from "../../../../../components";
import { useLazyGetSNTemplateByIdQuery } from "../../../../../redux/services";
import { AppRoutes } from "../../../../../router/routes";
import { MasterPath } from "../../util";
import { AddUpdateSNTemplate } from "./AddUpdateSNTemplate";

const SNTemplate: React.FC<{ children?: JSX.Element; currentPath?: string }> = (
  props
) => {
  const navigate = useNavigate();
  const { id = "" } = useParams();

  const isEdit = id !== "" && id !== "isNew";

  const history = [
    { label: "Tags & Template Module", onClick: () => false },
    {
      label: "Sequence Numbering (SN)",
      onClick: () => navigate(AppRoutes.sequenceNumbering(MasterPath.template)),
    },
    {
      label: "SN Template",
      onClick: () => navigate(AppRoutes.sequenceNumbering(MasterPath.template)),
    },
  ]

  const [getSNTemplate, snTemplateData] = useLazyGetSNTemplateByIdQuery();

  React.useEffect(() => {
    if (isEdit) {
      getSNTemplate({ id });
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <Box sx={{ padding: 0.5, height: "100%" }}>
      <Layout
        history={history}
        currentPath={isEdit ? snTemplateData?.data?.sequence_id ?? "..." : "New"}
        navBars={[]}
        mainPanel={<AddUpdateSNTemplate snTemplateData={snTemplateData} />}
        sideNavVariant={"whiteboard"}
        onBackBtnClick={() => navigate(AppRoutes.sequenceNumbering(MasterPath.template))}
        otherBreadscrumProps={{
          hideMenuBtn: true,
          showBackBtn: true
        }}
      />
    </Box>
  );
};

export default SNTemplate;
